import { Autocomplete, Box, CircularProgress, LinearProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@mui/material"
import { BasePathProvider } from "components/Providers"
import AdminListItem from "./AdminListItem"
import { useEffect, useState } from "react"
import { search as searchAdminEvaluation, clearEvaluation } from 'store/evaluation/admin-evaluation';
import { LightbulbTwoTone, SearchOffTwoTone } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import NoRecords from "components/NoRecords"
import { getCampusAcademicYears } from 'store/lookup';

export default function AdminList() {
    const headers = ['Admin Name', 'Site Visit 1', 'Site Visit 2', 'Summative Visit', 'Actions']
    const baseUrl = '/admin-evaluation/evaluation'
    const dispatch = useDispatch()
    const adminEvaluation = useSelector(state => state.adminEvaluation.evaluation.list)
    const [selectedCampus, setSelectedCampus] = useState(null)
    const [selectedAcademicYear, setSelectedAcademicYear] = useState(null)
    const campusAcademicYears = useSelector(state => state.lookup.campusAcademicYears)

    useEffect(() => {
        campusAcademicYears || dispatch(getCampusAcademicYears())
    }, [dispatch, Boolean(campusAcademicYears)])

    const filteredCampusAcademicYears = campusAcademicYears?.find(item => item.id === selectedCampus?.id)?.academicYears?.filter(year => year.isFullYear) || []

    useEffect(() => {
        if (filteredCampusAcademicYears && filteredCampusAcademicYears.length > 0) {
            const firstYear = filteredCampusAcademicYears[0];
            const isValid = selectedAcademicYear &&
                filteredCampusAcademicYears.some(year => year.id === selectedAcademicYear.id);

            if (!isValid) {
                setSelectedAcademicYear(firstYear);
            }
        } else {
            setSelectedAcademicYear(null);
            dispatch(clearEvaluation());
        }
    }, [filteredCampusAcademicYears]);

    useEffect(() => {
        if (selectedAcademicYear) {
            dispatch(searchAdminEvaluation({ academicYearId: selectedAcademicYear.id }));
        }
    }, [dispatch, selectedAcademicYear]);

    if (!campusAcademicYears) return <LinearProgress />

    return (
        <Box component={Paper} sx={{ width: '100%', p: 1, mb: 2 }}>
            <BasePathProvider value={`${baseUrl}`}>
                <Box px={1} py={2} display="flex" justifyContent="flex-start" gap={1} width={'100%'}>
                    <Autocomplete
                        options={campusAcademicYears}
                        getOptionLabel={(option) => option.name}
                        sx={{ width: '300px' }}
                        onChange={(event, value) => {
                            dispatch(clearEvaluation())
                            setSelectedCampus(value)
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"
                                label="Campus"
                            />
                        )}
                    />
                    {selectedCampus && (
                        <Autocomplete
                            options={filteredCampusAcademicYears}
                            getOptionLabel={(option) => option.name}
                            onChange={(event, value) => setSelectedAcademicYear(value)}
                            value={selectedAcademicYear}
                            disableClearable={true}
                            sx={{ width: '300px' }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    label="Academic Year"
                                />
                            )}
                        />
                    )}
                </Box>
                <TableContainer>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                {headers.map((header, index) => (
                                    <TableCell key={index}>{header}</TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {selectedCampus ? (
                                adminEvaluation && adminEvaluation.length > 0 ? (
                                    adminEvaluation.map((item, index) => (
                                        <AdminListItem key={index} item={item} selectedAcademicYear={selectedAcademicYear} />
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={headers.length} align="center">
                                            {adminEvaluation === null ? (
                                                <CircularProgress />
                                            ) : (
                                                <NoRecords icon={<SearchOffTwoTone sx={{ fontSize: 50, color: "primary.main" }} />} message="No records found" />
                                            )}
                                        </TableCell>
                                    </TableRow>
                                )
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={headers.length} align="center">
                                        <NoRecords icon={<LightbulbTwoTone sx={{ fontSize: 50, color: "primary.main" }} />} message="Select a campus to see the list of admins." />
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </BasePathProvider>
        </Box>
    )
}
